"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = InfoSmall;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _InfoSmall = require("@adobe/react-spectrum-ui/dist/InfoSmall");

var _icon = require("@react-spectrum/icon");

var _provider = require("@react-spectrum/provider");

var _react = _interopRequireDefault(require("react"));

const ExpressIcon = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 14 14"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M7 1a6 6 0 1 0 6 6 6.007 6.007 0 0 0-6-6Zm.867 8.677a.868.868 0 0 1-1.734 0V7a.868.868 0 0 1 1.734 0v2.676ZM7 5.4c-.662 0-1.2-.538-1.2-1.2S6.338 3 7 3s1.2.539 1.2 1.2S7.662 5.4 7 5.4Z"
}));

ExpressIcon.displayName = _InfoSmall.InfoSmall.displayName;

function InfoSmall(props) {
  var _provider$theme, _provider$theme$globa;

  let provider = (0, _provider.useProvider)();
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/_react.default.createElement(ExpressIcon, null) : /*#__PURE__*/_react.default.createElement(_InfoSmall.InfoSmall, null));
}